import React, { useState } from "react";
import "../../styles/components/ContactsHero.css";

import contactsBg from "../../img/hero/contacts-hero-2.webp";
import btnArrow from "../../img/hero/arrow-herro.png";

import Modal from "../../components/Modal";            // ✅ модалка
import ContactFormSimple from "../../components/ContactFormSimple"; // ✅ форма

export default function ContactsHero() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="contacts-cta contacts-cta-anim" aria-label="Contacts CTA hero">
      {/* Правий образ */}
      <img
        className="contacts-cta__bg contacts-cta-anim__art"
        src={contactsBg}
        alt=""
        aria-hidden="true"
      />

      {/* Заголовок (зліва) */}
      <div className="contacts-cta__title contacts-cta-anim__title">
        <h1 className="contacts-cta__h1">
          Let’s Build Something <strong>Incredible</strong>
          <br />
          Together
        </h1>
      </div>

      {/* Низ: підзаголовок + кнопка */}
      <div className="contacts-cta__bottom contacts-cta-anim__bottom">
        <p className="contacts-cta__lead">
          Personalized AI agents, analytics, content generation, and marketing automation — built on deep user context and designed to move your product metrics.
        </p>

        <button
          type="button"
          className="Secondary v2"
          onClick={() => setOpenModal(true)}
        >
          <span className="Secondary__text">Start Your Project</span>
          {btnArrow ? (
            <img
              className="Secondary__circle"
              src={btnArrow}
              alt=""
              aria-hidden="true"
            />
          ) : (
            <span className="Secondary__circle">➜</span>
          )}
        </button>
      </div>

      {/* Модалка */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
